<template>
  <div id="teacher_custom">
    <div class="over_ta">
      <div class="tea_li" style="margin-bottom: 40px;">
        <div class="tea_title"><i class="fa fa-chevron-circle-down mr5" aria-hidden="true"></i>{{showName(customs[custom])}}</div>
        <div class="tea_tx" v-html="showContext(customs[custom])">內容</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher_custom',
  props: ['customs'],
  data() {
    return {
      custom: this.$route.params.custom,
      info: {},
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  watch: {
    $route() {
      this.custom = this.$route.params.custom;
    }
  },
  created() {
  },
  methods: {
    

    showName(custom) {
      let show = {'CH': custom.nameCh, 'EN': custom.nameEn}
      return show[sessionStorage.locale];
    },
    showContext(custom) {
      let show = {'CH': (custom.contextCh), 'EN': (custom.contextEn)};
      return show[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// TeacherCustom.vue?5b9fd48b